import React, { useState, useEffect } from "react";
import "./loginForm.css";
import strings from "../utils/property-file/loginForm.json";
import "./inputBox/emailInput/emailInput.css";
import  "./inputBox/passwordInput/passwordInput.css";
import { useNavigate } from "react-router-dom";
import Ripple from "./button/ripple";
import auth from "../services/auth";
import constants from "../utils/constants";
import { toast } from "react-toastify";
import UsePasswordToggle from "./usePasswordToggle";
import { useForm } from "react-hook-form";
import packageJson from "../../package.json";
import { requestPermission } from "../firebase";
import Favicon from "react-favicon";
import HourHiveLogo from "../Asset/Images/logoImage.png"
import HourHiveNewLogo from "../Asset/Images/hh-logo.svg"
import SpinnerButtonMedium from "./button/SpinnerButtonMedium";
import webDetails from "../../package.json"



export default function LoginForm() {


  // useEffect(() => {
  //   document.title = strings.hourHiveLabel;
  // }, []);



  useEffect(() => {
    setTimeout(() => {
     
    }, 200);
    if (localStorage.getItem("session")) {
      nav(constants.navigationLink.dashboardLink);
    }
  }, []);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const nav = useNavigate();
  const [PasswordInputType, ToggleIcon] = UsePasswordToggle();
  const [logIn, setLogIn] = useState(false);
  const copyrightYear = new Date().getFullYear();



  const login = async (data) => {
    const token = await requestPermission();
    try {
      let body = {
          email: data.email,
          password: data.password,
          token: token ? token.toString() : null,
          webPlatform : strings.webLabel,
          webAppVersion : webDetails.version
      };
      setLogIn(true);
      let response = await auth.login(body);
      console.log("response:::",response);
      if (response && response.data) {
        const data = JSON.parse(response.data);
         console.log("response:::",data);
        if (response.success) {
          localStorage.setItem("session", data.sessionKey);
          localStorage.setItem("company_info", data.user_info.name);
          localStorage.setItem("company_id", data.user_info._id);
          localStorage.setItem("isSuperAdmin",data.user_info.isSuperAdmin);
          localStorage.setItem("userName", data.user_info.userName)
          localStorage.setItem('allowMultipleCheckInOut',data.user_info.allowMultipleCheckInOut)
          localStorage.setItem('isCheckoutTimeEditable',data.user_info.isCheckoutTimeEditable)
          localStorage.setItem('enableAutoCheckout',data.user_info.enableAutoCheckout)
           localStorage.setItem('isCheckInTimeEditable',data.user_info.isCheckInTimeEditable)
          nav(constants.navigationLink.dashboardLink);
        } else {
          toast.error(data.body, { toastId: "error7" });
        }
      }
      setLogIn(false)
    } catch (error) {
      setLogIn(false);
      toast.error(strings.somethingWentWrong, { toastId: "error7" });
    }
  };
  
  return (
    <>
    <Favicon url={HourHiveLogo}/>
        <>
          <div className="whole-Form">
            <div className="main-container row">
              <div className="logo-container">
                <div className="">
                  
                
                </div>
                
              </div>
              <form className="input" onSubmit={handleSubmit(login)}>
                  <div className="logo-container">
                    <img className="logo img-fluid"src={HourHiveNewLogo} alt="" />
                  </div>
                <div className="login-string">
                  <h5 className="text-light forgot-page col-12 d-block">
                    {strings.Login}
                  </h5>
                </div>
                <div className="email-btn ">
                  <div className="form-floating mb-3 email-up-div">
                    <input
                      name="email"
                      type="email"
                      className={
                        errors.email
                          ? "form-control validateEmail email-input pb-0 input-text-alert"
                          : "form-control validateEmail email-input pb-0"
                      }
                      id="email"
                      placeholder=" "
                      autoComplete="off"
                      {...register("email", {
                        required: strings.emailCheck,
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                          message: strings.emailValidate,
                        },
                      })}
                    />
                    <label
                      htmlFor="floatingInput"
                      className="text-light input-place"
                    >
                      {strings.email}
                    </label>
                    <div className="form-validation">
                      <small>
                        {errors.email && (
                          <span className="position-absolute">
                            <strong className="me-1">&#9432;</strong>
                            {errors.email.message}
                          </span>
                        )}
                      </small>
                    </div>
                  </div>
                </div>
                <div className="form-floating email-up-div">
                  <input
                    type={PasswordInputType}
                    {...register("password", {
                      required: strings.passCheck,
                    })}
                    name="password"
                    className={
                      errors.password
                        ? "form-control validateEmail email-input pb-0 input-text-alert"
                        : "form-control validateEmail email-input pb-0"
                    }
                    id="password"
                    placeholder=" "
                  />
                  <label
                    htmlFor="floatingPassword"
                    className="text-light input-place "
                  >
                    {strings.placeHolderPassword}
                  </label>
                  <span className="password-toggle-icon text-light">
                    {ToggleIcon}
                  </span>
                  <div className="form-validation">
                    <small>
                      {errors.password && (
                        <span className="position-absolute">
                          <strong className="me-1">&#9432;</strong>
                          {errors.password.message}
                        </span>
                      )}
                    </small>
                  </div>
                </div>
                <div className="forgot-link mx-auto">
                  <p className="forgot-message text-end">
                    <span className="text-light m-1">
                      {strings.forgotMessage}
                    </span>
                    <span
                      onClick={() => {
                        nav(constants.navigationLink.forgetPasswordLink);
                      }}
                      className="forgot-page-link"
                    >
                      {strings.forgotPassword}
                    </span>
                  </p>
                </div>
                <div className="button-submit">
                      <button
                      type="submit"
                      disabled={logIn}
                      className="btn btn-primary text-center mt-3 forgot-submit-btn"
                    >
                      {logIn ?<SpinnerButtonMedium /> :  strings.submit}
                      <Ripple duration={1000} />
                    </button>
                </div>
                <div className="button-submit create-organization-btn">
                  <p className="create-organization-whole-message">
                    <span
                      className="create-organization-message"
                      onClick={() => {
                        nav(constants.navigationLink.companyRegLink, {
                          state: true,
                        });
                      }}
                    >
                      {strings.createOrganizationLabel}
                    </span>
                  </p>
                </div>
              </form>
            </div>
            <div className="copy-right-container">
              <div className="app-version text-center">
                <div className="all-copyright-content">
                  <span>{strings.appName}</span>
                  <span>
                    {strings.labelVersion}:- {packageJson.version}
                  </span>
                  <p>
                    {strings.copyrightSign} <span className="me-1">{copyrightYear}</span>
                    <a href="https://synclovis.com">
                      {strings.companyName}
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </>
    </>
  );
}
